import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapIconsModule } from 'ng-bootstrap-icons';
import { Alarm, App, Bookmark, CheckCircleFill, QuestionCircleFill, XCircleFill, InfoCircleFill,XCircle, ArrowLeftCircleFill, CloudArrowDownFill} from 'ng-bootstrap-icons/icons';

// documentación iconos aqui: https://avmaisak.github.io/ngx-bootstrap-icons/home


// Select some icons (use an object, not an array)
const icons = {
  Alarm,
  App,
  Bookmark,
  CheckCircleFill,
  QuestionCircleFill,
  XCircleFill,
  InfoCircleFill,
  XCircle,
  ArrowLeftCircleFill,
  CloudArrowDownFill
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BootstrapIconsModule.pick(icons)
  ],
  exports: [
    BootstrapIconsModule
  ]
})
export class IconsModule { }

// NOTES:
// 1. We add BootstrapIconsModule to the 'exports', since the <bi> component will be used in templates of parent module
// 2. Don't forget to pick some icons using BootstrapIconsModule.pick({ ... })